import ThreadMessageIcon from './ThreadMessageIcon';

const ThreadMessageIconThread = () => <ThreadMessageIcon name='thread' />;

export default ThreadMessageIconThread;
